import { Injectable } from '@angular/core';
import { Platform, Events } from 'ionic-angular';
import 'rxjs/add/operator/map';

/*
  Generated class for the Timeprovider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class Timeprovider {

  constructor(public events: Events, private platform: Platform) {
    console.log('starting interval');
    setInterval(()=>{this.events.publish('time_ms', Date.now())},10000);
  }
}



// WEBPACK FOOTER //
// ./src/providers/timeprovider.ts